export const getParamsFromUrl = urlSearchStr => {
    if(urlSearchStr) {
        const searchString = decodeURIComponent(urlSearchStr);
        let ParamsFromUrl = {};

        searchString.replace('?', '').split('&').forEach(param => {
            const key = param.split('=')[0];
            const value = param.split('=')[1];

            ParamsFromUrl[key] = key === 'id' ? +value : value;
        });

        return ParamsFromUrl;
    } else {
        return null;
    }
};